import { Maybe } from "ramda-fantasy";
import moment from "moment";

import { maybeEmpty, parseDate, parseDateFromJSString } from "../../../../util";

export const createDateColumn = (getter, col) => {
  return {
    allowedAggFuncs: ["first", "last", "maxDate", "minDate"],
    filter: "agDateColumnFilter",
    filterParams: {
      comparator: (a, b) => {
        if (b) {
          const parsedB = parseDate(b, "DD/MM/YYYY")
            .map(date => moment(date, "DD/MM/YYYY"))
            .getOrElse(null);
          return parsedB == null
            ? null
            : parsedB.toDate().getTime() - a.getTime();
        } else {
          return null;
        }
      },
    },
    comparator: (a, b) => {
      const parsedA = parseDate(a, "DD/MM/YYYY")
        .map(date => moment(date, "DD/MM/YYYY"))
        .getOrElse(null);
      const parsedB = parseDate(b, "DD/MM/YYYY")
        .map(date => moment(date, "DD/MM/YYYY"))
        .getOrElse(null);
      if (parsedA && parsedB) {
        return parsedA.toDate().getTime() - parsedB.toDate().getTime();
      } else {
        return String(a || "").localeCompare(String(b || ""));
      }
    },

    valueGetter: params => maybeEmpty(getter(params)).getOrElse(""),

    valueFormatter: params => {
      let value = maybeEmpty(params.value).chain(parseDate);

      if (Maybe.isNothing(value) && typeof params.value === "string") {
        value = maybeEmpty(params.value).chain(parseDateFromJSString);
      }

      return value
        .map(date =>
          //permite que apareca na tela de resultado valores em texto e no formato dd/MM/yyyy
          !moment(date).isValid() && new RegExp("[^0-9]").test(params.value)
            ? null
            : moment(date).format(col.format)
        )
        .getOrElse(getter(params));
    },
  };
};
